module.exports = __webpack_public_path__ + "static/img/zd08.0daf57d8.svg";